var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({class:[_vm.iconSizeClass, _vm.iconTestClass],attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',_vm._b({},'use',{ 'xlink:href': _vm.spriteHref },false))])}
var staticRenderFns = []

export { render, staticRenderFns }